<template>
  <el-dialog
    width="30%"
    title="导入"
    v-model="dialogVisible"
    :before-close="handleClose"
  >
    <div class="excelTempate">
      <el-button
        type="primary"
        @click="downloadExcelTempate"
        plain
      >下载导入模版</el-button>
    </div>
    <el-upload
      class="upload-demo"
      drag
      action=""
      :headers="headers"
      :on-success="success"
      :on-error="error"
      multiple:false
      :before-upload="beforeUpload"
    >
      <el-icon class="el-icon--upload">
        <upload-filled />
      </el-icon>
      <div class="el-upload__text">
        拖拽 <em>双击导入</em>
        <div class="el-upload__tip">只能上传xls/xlsx文件，且不超过一个</div>
      </div>
    </el-upload>
  </el-dialog>
  <ErrorMessage
    v-model:djEditVisible="djEditVisible"
    :djTitle="datalist2.title"
    :tableData="datalist2.tableData"
    :tablekey="datalist2.tablekey"
    :isExcel="datalist2.isExcel"
  ></ErrorMessage>
</template>

<script>
import { reactive, toRefs } from "vue";
import { ElNotification, ElLoading } from "element-plus";
import ErrorMessage from "./ErrorMessage";
import download from "@/util/download";
 import { post } from '@/util/request'
export default {
  emits: ["close-dialog", "error", "success"],
  name: "upload",
  props: {
    dialogVisible: false,
    fileName: "",
    controlName: "",
    type: "",
  },
  components: {
    ErrorMessage,
  },
  created() {},
  setup(pro, content) {
    // const VUE_APP_API_URL = (process.env.NODE_ENV  != 'production' ? serverConfig.devURL: serverConfig.proURL) 
    // + `/api/app/${pro.controlName}/import`;
    let Base64 = require("js-base64").Base64;
    let UserInfo = Base64.encode(localStorage.getItem("UserInfo"));
    const headers = {
      UpdateUser: UserInfo,
    };
    const data = reactive({
      djEditVisible: false,
      datalist2: {
        isExcel: true,
        title: "导入失败记录",
        tablekey: [
          {
            name: "行号",
            value: "lineNum",
          },
          {
            name: "档案信息",
            value: "lineKey",
          },
          {
            name: "错误信息",
            value: "message",
          },
        ],
        tableData: [],
      },
      loading: null,
    });

    const downloadExcelTempate = () => {
      let defaluturl = `/api/app/${pro.controlName}/exportExcelTemplates`;
      const params = {
        fileName: pro.fileName,
      };
      //下载模版
      download(pro.fileName, defaluturl, params);
    };
    const beforeUpload = (file) => {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 xls、xlsx格式!",
          type: "warning",
        });
        return false;
      }
      data.loading = ElLoading.service({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const formData = new FormData()
      formData.append("file", file);
      formData.set('type', pro.type)
      post(`/api/app/${pro.controlName}/import`,formData).then(({ errorResults, successCount } ) => {
        data.loading.close();
        ElNotification({
          title: "Success",
          message: "导入成功" + successCount + "条记录",
          type: "success",
        });
        content.emit("success", "导入成功");
        content.emit("close-dialog", "UplaodClose");
        if (errorResults != null && errorResults.length > 0) {
          data.djEditVisible = true;
          data.datalist2.tableData = errorResults;
        }
      }).catch(() => {
         data.loading.close();
        ElNotification({
          title: "Error",
          message: "导入失败",
          type: "error",
        });
        content.emit("error", "error");
        content.emit("close-dialog", "UplaodClose");
      })
      return false
    };
    const success = (response, file, fileList) => {
      data.loading.close();
      let { errorResults, successCount } = response;
      ElNotification({
        title: "Success",
        message: "导入成功" + successCount + "条记录",
        type: "success",
      });
      content.emit("success", "导入成功");
      content.emit("close-dialog", "UplaodClose");
      if (errorResults != null && errorResults.length > 0) {
        data.djEditVisible = true;
        data.datalist2.tableData = errorResults;
      }
    };
    const error = (error, file, fileList) => {
      data.loading.close();
      ElNotification({
        title: "Error",
        message: "导入失败",
        type: "error",
      });
      content.emit("error", "error");
      content.emit("close-dialog", "UplaodClose");
    };
    const handleClose = () => {
      content.emit("close-dialog", "UplaodClose");
    };
    return {
      ...toRefs(data),
      downloadExcelTempate,
      // VUE_APP_API_URL,
      headers,
      handleClose,
      success,
      error,
      beforeUpload,
    };
  },
};
</script>

<style scoped>
.excelTempate {
  margin-bottom: 5px;
  text-align: center;
}
.upload-demo{
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
